module.exports = __webpack_public_path__ + "static/media/PC5-5.d701d64a.jpg";